import { createTheme } from "@mui/material/styles";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { styled } from "@mui/system";
import "../globals.scss";

const StyledKeyboardArrowDownIcon = styled(KeyboardArrowDownIcon)(
  ({ theme }) => ({
    color: `${theme.palette.primary.main} !important`,
    fontSize: 14,
  })
);

export const lightTheme = createTheme({
  components: {
    // MuiAutocomplete: {
    //   defaultProps: {
    //     popupIcon: <StyledKeyboardArrowDownIcon />,
    //   },
    // },
    // MuiSelect: {
    //   defaultProps: {
    //     IconComponent: StyledKeyboardArrowDownIcon,
    //   },
    // },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiButton: {
      styleOverrides: {
        // Neutral greys matching the storefront's black-and-white CTAs.
        contained: {
          "&.Mui-disabled": {
            backgroundColor: "#d4d4d4",
            color: "#737373",
          },
        },
        outlined: {
          "&.Mui-disabled": {
            backgroundColor: "transparent",
            borderColor: "rgba(0,0,0,0.12)",
            color: "rgba(0,0,0,0.3)",
          },
        },
        text: {
          "&.Mui-disabled": {
            backgroundColor: "transparent",
            color: "rgba(0,0,0,0.3)",
          },
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fontSize: "16px",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "primary",
            borderWidth: "1px",
          },
        },
      },
    },
  },
  typography: {
    fontSize: 12,
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    allVariants: {
      color: "#1c1c1c",
    },
  },
  palette: {
    mode: "light",
    primary: {
      light: "#1A307A",
      main: "#1A307A",
    },
    secondary: {
      main: "#9B8DFF",
    },
    success: {
      main: "#23b92a",
    },
    text: {
      primary: "#1A307A",
      disabled: "#595959",
    },
  },
});
